import PropTypes from 'prop-types';
import React from 'react';
import { StyledAvatar, StyledImg } from './styles';

export type AvatarProps = {
  src: string;
  alt?: string;
  width?: string;
  height?: string;
  isDisabled?: boolean;
  backgroundColor?: string;
  imgHeight?: string;
};

const Avatar: React.FC<AvatarProps> = (props: AvatarProps) => {
  const { src, alt, width, height, isDisabled, backgroundColor, imgHeight } = props;
  return (
    <StyledAvatar
      src={src}
      width={width}
      height={height}
      backgroundColor={backgroundColor}
      imgHeight={imgHeight}
    >
      <StyledImg src={src} alt={alt} isDisabled={isDisabled} />
    </StyledAvatar>
  );
};

Avatar.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  isDisabled: PropTypes.bool,
  backgroundColor: PropTypes.string,
  imgHeight: PropTypes.string
};

Avatar.defaultProps = {
  alt: '',
  src: '/assets/images/default-logo.svg',
  width: '2.5rem',
  height: '2.5rem',
  isDisabled: false,
  backgroundColor: 'transparent',
  imgHeight: ''
};

export default Avatar;
